export const requestDeliveryLocation = (geolocation = navigator.geolocation) => {
  if (!geolocation) return Promise.reject(new Error('Geolocation not supported'));
  return new Promise((resolve, reject) => {
    geolocation.getCurrentPosition(
      ({ coords }) => resolve({
        latitude: coords.latitude,
        longitude: coords.longitude,
        accuracy: coords.accuracy,
      }),
      reject,
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 },
    );
  });
};
